import React from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { ValidatingInput, ValidatingTextArea } from '@/components/forms/validation';
import { ProjectTag } from '@/types';
import { TagInput } from '@/components/TagInput';

export interface MergedChangeRequest {
    subject: string;
    description: string;
    tags: ProjectTag[];
}

interface ChangeRequestMergeWizardStepEditProps {
    value: MergedChangeRequest;
    onChange(newValue: MergedChangeRequest): void;
}

const ChangeRequestMergeWizardStepEdit: React.FC<ChangeRequestMergeWizardStepEditProps> = ({ value, onChange }) => {
    const handleChange = (changes: Partial<MergedChangeRequest>) => {
        onChange({ ...value, ...changes });
    };

    return (
        <div className="form columns-1">
            <label>
                <Trans>Subject</Trans>
                <ValidatingInput
                    placeholder={t`Subject`}
                    className="form-control"
                    value={value.subject}
                    onChange={(e) => handleChange({ subject: e.target.value })}
                    required
                />
            </label>
            <label>
                <Trans>Description</Trans>
                <ValidatingTextArea
                    placeholder={t`Description`}
                    className="form-control"
                    value={value.description}
                    onChange={(e) => handleChange({ description: e.target.value })}
                    required
                    autoResize
                    minRows={2}
                    maxRows={10}
                />
            </label>
            <label>
                <Trans>Tags</Trans>
                <TagInput value={value.tags} onTagsChange={(newTags) => handleChange({ tags: newTags })} />
            </label>
        </div>
    );
};

export default ChangeRequestMergeWizardStepEdit;
